// Price and fee calculations

import { state } from '../state';

export function calculateSubtotal(): number {
    return state.products.reduce((total, product) => {
        const quantity = state.selections.get(product.id) || 0;
        return total + (product.price * quantity);
    }, 0);
}

export function getCommitmentFee(): number {
    return Math.round(calculateSubtotal() / 2);
}

export function getBalanceDue(): number {
    return calculateSubtotal() - getCommitmentFee();
}

// Calculate Paystack transaction fee (1.5% + ₦100, capped at ₦2,000)
export function calculateTransactionFee(): number {
    const commitmentFee = getCommitmentFee();
    const PERCENTAGE_FEE = 0.015; // 1.5%
    const FLAT_FEE = 100; // ₦100
    const FEE_CAP = 2000; // ₦2,000

    // Calculate amount to charge including fees
    const preliminaryAmount = Math.ceil((commitmentFee + FLAT_FEE) / (1 - PERCENTAGE_FEE));

    // Calculate what the actual fee would be
    let transactionFee = Math.ceil(preliminaryAmount * PERCENTAGE_FEE) + FLAT_FEE;

    // Apply the fee cap if necessary
    if (transactionFee > FEE_CAP) {
        transactionFee = FEE_CAP;
    }

    return transactionFee;
}

export function getAmountToPay(): number {
    return getCommitmentFee() + calculateTransactionFee();
}

export function getTotalItemCount(): number {
    let count = 0;
    state.selections.forEach(qty => count += qty);
    return count;
}

export function hasFreeBag(): boolean {
    return getTotalItemCount() >= 3;
}

export function getSelectedItems() {
    return state.products.filter(p => (state.selections.get(p.id) || 0) > 0);
}
